<template>
  <div class="row moat-header">
    <div v-if="!isEmotionalIdeals" class="breakway-moats moat-header-border">
      <div class="moat-header-section-header">Breakaway Moats</div>
      <div class="row">
        <div class="header-11 moat-type moat-type-5">
          <div>Value</div>
          <div>Chain</div>
        </div>
        <div class="header-10 moat-type moat-type-4">Design Dominance</div>
        <div class="header-7 moat-type moat-type-5">Channel<br />Lock-Out</div>
        <div class="header-1 moat-type moat-type-4">Distinct Innovation</div>
      </div>
    </div>
    <div v-if="!isEmotionalIdeals" class="first-mover-moats moat-header-border">
      <div class="moat-header-section-header">Early-Mover Moats</div>
      <div class="row">
        <div class="header-5 moat-type moat-type-4">Routine Reliance</div>
        <div class="header-9 moat-type moat-type-3">Economies<br />of Scale</div>
        <div class="header-6 moat-type moat-type-2">Switching Lock-In</div>
        <div class="header-4 moat-type moat-type-1">Network<br />Effect</div>
      </div>
    </div>
    <div v-if="!isEmotionalIdeals" class="promise-moats moat-header-border">
      <div class="moat-header-section-header">Promise Moats</div>
      <div class="row">
        <div class="header-3 moat-type moat-type-3">Time Authenticity</div>
        <div class="header-8 moat-type moat-type-3">Economies<br />of Skill</div>
        <div class="header-2 moat-type moat-type-2">Brand<br />Perception</div>
       <div class="moat-type-filler"></div>
      </div>
    </div>
    <div v-if="isEmotionalIdeals" class="emotional-ideals moat-header-border">
      <div class="moat-header-section-header">Emotional Ideals</div>
      <div class="row">
        <div class="header-emotional-ideals-1 moat-type moat-type-5">
          <div>Assurance</div>
          <div>Level</div>
        </div>
        <div class="header-emotional-ideals-2 moat-type moat-type-4">
          <div>Curiosity</div>
          <div>Level</div>
        </div>
        <div class="header-emotional-ideals-3 moat-type moat-type-3">
          <div>Strictness</div>
          <div>Level</div>
        </div>
        <div class="header-emotional-ideals-4 moat-type moat-type-2">
          <div>Trust</div>
          <div>Level</div>
        </div>
        <div class="header-emotional-ideals-5 moat-type moat-type-1">
          <div>Activity</div>
          <div>Level</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoatHeader",
  data() {
    return {};
  },
  props: {
    isEmotionalIdeals: {
      type: Boolean,
      default: false
    }
  }
};
</script>
